import { render, staticRenderFns } from "./ServiceParagraph.vue?vue&type=template&id=ced13e4a&scoped=true"
import script from "./ServiceParagraph.vue?vue&type=script&lang=js"
export * from "./ServiceParagraph.vue?vue&type=script&lang=js"
import style0 from "./ServiceParagraph.vue?vue&type=style&index=0&id=ced13e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced13e4a",
  null
  
)

export default component.exports